module.exports = __webpack_public_path__ + "img/MHU_2.bf469eb5.png";